import styled from 'styled-components';

export const FAQWrapper = styled.section<{ $isVisible?: boolean }>`
  background: #0a0a0a;
  padding: 120px 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 250px;
    background: linear-gradient(180deg,
      transparent 0%,
      rgba(255, 68, 68, 0.005) 15%,
      rgba(255, 68, 68, 0.015) 40%,
      rgba(255, 68, 68, 0.03) 70%,
      rgba(255, 68, 68, 0.05) 100%
    );
    pointer-events: none;
    z-index: 1;
  }

  @media (max-width: 768px) {
    padding: 80px 0;
  }
`;

export const FAQGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: stretch;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    max-width: 800px;
  }
`;

export const FAQList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FAQListItem = styled.button<{ $active?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  border-radius: ${props => props.theme.borders.radius.md};
  border: 1px solid ${p => (p.$active ? 'rgba(255,68,68,0.22)' : 'rgba(255,255,255,0.06)')};
  background: ${p => (p.$active ? 'rgba(255,255,255,0.04)' : 'rgba(255,255,255,0.02)')};
  color: #e4e4e7;
  text-align: left;
  cursor: pointer;
  transition: background 0.35s cubic-bezier(0.4,0,0.2,1),
              border-color 0.35s cubic-bezier(0.4,0,0.2,1),
              transform 0.2s ease;

  &:hover { background: rgba(255,255,255,0.04); }
  &:focus-visible { outline: 2px solid rgba(255,68,68,0.35); outline-offset: 2px; }
`;

export const FAQDetail = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const FAQDetailCard = styled.div`
  height: 100%;
  border: 1px solid rgba(255,255,255,0.06);
  background: rgba(255,255,255,0.02);
  border-radius: ${props => props.theme.borders.radius.lg};
  overflow: hidden;
  padding: 28px;
  transition: border-color 0.35s cubic-bezier(0.4,0,0.2,1), background 0.35s cubic-bezier(0.4,0,0.2,1);

  &[data-active="true"] {
    border-color: rgba(255,255,255,0.12);
    background: rgba(255,255,255,0.03);
  }
`;

export const FAQRichPreview = styled.div<{ $activeIndex?: number }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  border-radius: ${props => props.theme.borders.radius.md};
  background: linear-gradient(180deg, rgba(18,18,18,0.9), rgba(14,14,14,0.9));
  border: 1px solid rgba(255,255,255,0.08);
  padding: 28px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  /* Animação do conteúdo quando muda */
  .content-wrapper {
    animation: ${props => props.$activeIndex !== undefined ? 'fadeInScale 0.5s cubic-bezier(0.4, 0, 0.2, 1)' : 'none'};
  }

  @keyframes fadeInScale {
    0% {
      opacity: 0;
      transform: translateY(8px) scale(0.98);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  .kicker {
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    font-weight: 600;
    font-size: 12px;
  }

  .title {
    color: #fafafa;
    font-size: 22px;
    line-height: 1.3;
    font-weight: 700;
    letter-spacing: -0.01em;
  }

  .lead {
    color: #d4d4d8;
    font-size: 15px;
    line-height: 1.75;
  }

  .divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent);
    margin: 6px 0 2px;
  }

  .list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 8px;
  }

  .item {
    color: #c4c4c7;
    font-size: 15px;
    line-height: 1.6;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 0;
  }

  .item-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-top: 2px;
    opacity: 0.8;
  }

  .note {
    color: #9ca3af;
    font-size: 12px;
    line-height: 1.6;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.06);
    padding: 10px 12px;
    border-radius: ${props => props.theme.borders.radius.base};
  }
`;

export const FAQQuestion = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #fafafa;
`;

export const PlusMinus = styled.span<{ $open?: boolean }>`
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ff4444;
  font-weight: 800;
  font-size: 20px;
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: rotate(${p => (p.$open ? '180deg' : '0deg')}) scale(${p => (p.$open ? 1.05 : 1)});
`;
